<template>
  <div>
    <banner></banner>
    <anchor-nav></anchor-nav>
    <pluma></pluma>
    <!-- <areas></areas> -->
    <executives></executives>
    <trainers></trainers>

    <footer-component></footer-component>
  </div>
</template>

<script>
import store from '@/store'
import LogoIcon from '@/components/Icons/LogoIcon'
import $ from 'jquery'
import AOS from 'aos'
import 'aos/dist/aos.css'
import Banner from './partials/Banner'
import AnchorNav from './partials/Nav'
import Pluma from './partials/Pluma'
import Areas from './partials/Areas'
import Executives from './partials/Executives'
import Trainers from './partials/Trainers'

export default {
  store,

  name: 'About',

  components: {
    LogoIcon,
    AOS,
    Banner,
    AnchorNav,
    Pluma,
    Areas,
    Executives,
    Trainers,
  },

  mounted () {
    setTimeout(function () {
      AOS.init()
    }, 400)

    this.scrollNav()
  },

  methods: {
    scrollNav () {
      /*eslint-disable*/
      // Select all links with hashes
      $('a[href*="#"]')
      // Remove links that don't actually link to anything
      // .not('[href="#"]')
      // .not('[href="#0"]')
      .click(function(event) {
        // On-page links
        if (
          location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
          &&
          location.hostname == this.hostname
        ) {
          // Figure out element to scroll to
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
          // Does a scroll target exist?
          if (target.length) {
            // Only prevent default if animation is actually gonna happen
            // event.preventDefault();
            $('html, body').animate({
              scrollTop: target.offset().top
            }, 700, function() {
              // Callback after animation
              // Must change focus!
              // var $target = $(target);
              // $target.focus();
              // if ($target.is(":focus")) { // Checking if the target was focused
              //   return false;
              // } else {
              //   $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
              //   $target.focus(); // Set focus again
              // };
            });
          }
        }
      });
    },
  },
}
</script>
